import * as mutationTypes from './mutation-types'
import { dateTimeFormatFr } from '@/utils/data/date'

/**
 * Helper pour la mise à jour du fetching
 * @param state
 * @param fetching
 */
const setFetching = (state, fetching) => {
  state.fetching = {
    ...state.fetching,
    ...fetching
  }
}

/**
 * Factory pour le remplacement
 * @param k
 * @returns {function(...[*]=)}
 */
const setKey = (k) => (state, newK) => {
  state[k] = newK
  setFetching(state, { [k]: dateTimeFormatFr(new Date()) })
}

/**
 * Factory pour l'ajout / Modification
 * @param k
 * @returns {function(...[*]=)}
 */
const setIndex = (k) => (state, newEl) => {
  const target = state[k]
  const i = target.findIndex((el) => el.id === newEl.id)
  if (i === -1) {
    target.push(newEl)
  } else {
    target.splice(i, 1, newEl)
  }
}

/**
 * Factory pour la suppression
 * @param k
 * @returns {function(...[*]=)}
 */
const deleteIndex = (k) => (state, del) => {
  const target = state[k]
  const i = target.findIndex((el) => el.id === del.id)
  if (i !== -1) {
    target.splice(i, 1)
  }
}

export default {
  [mutationTypes.USER_AGENCY_AGENT_REQUEST_UNREAD]: (state, agentRequestUnread) => {
    state.agentRequestUnread = agentRequestUnread
  },

  [mutationTypes.USER_AGENCY_SET_FETCHING]: setFetching,
  [mutationTypes.USER_AGENCY_SET_PRICING]: setKey('pricing'),
  // Agencies
  [mutationTypes.USER_AGENCY_SET_AGENCIES]: setKey('agencies'),
  [mutationTypes.USER_AGENCY_SET_AGENCY]: setIndex('agencies'),
  // Sites
  [mutationTypes.USER_AGENCY_SET_SITES]: setKey('sites'),
  [mutationTypes.USER_AGENCY_SET_SITE]: setIndex('sites'),
  [mutationTypes.USER_AGENCY_DELETE_SITE]: deleteIndex('sites'),
  // Agents
  [mutationTypes.USER_AGENCY_SET_AGENTS]: setKey('agents'),
  [mutationTypes.USER_AGENCY_SET_AGENT]: setIndex('agents'),
  [mutationTypes.USER_AGENCY_DELETE_AGENT]: deleteIndex('agents'),
  // Clients
  [mutationTypes.USER_AGENCY_SET_CLIENTS]: setKey('clients'),
  [mutationTypes.USER_AGENCY_SET_CLIENT]: setIndex('clients'),
  [mutationTypes.USER_AGENCY_DELETE_CLIENT]: deleteIndex('clients'),
  // Rondes
  [mutationTypes.USER_AGENCY_SET_RONDES]: setKey('rondes'),
  [mutationTypes.USER_AGENCY_SET_RONDE]: setIndex('rondes'),
  [mutationTypes.USER_AGENCY_DELETE_RONDE]: deleteIndex('rondes'),
  // Checkpoints
  [mutationTypes.USER_AGENCY_SET_CHECKPOINTS]: setKey('checkpoints'),
  [mutationTypes.USER_AGENCY_SET_CHECKPOINT]: setIndex('checkpoints'),
  [mutationTypes.USER_AGENCY_DELETE_CHECKPOINT]: deleteIndex('checkpoints')
}
